import { get } from 'lodash';
import { ColorRecipeModel } from '../edit/models/color-recipe.model';


export namespace ObjectColor {
  export function getColorRecipe(Human: any, objectId: string): ColorRecipeModel {
    const humanObject = Human.scene.objects[objectId];
    if (humanObject instanceof Human.scene.Object) {
      const prop = humanObject.getProperties();
      const colorProp = {
          tintColor: get(prop, 'tintColor') ? prop.tintColor : [1, 1, 1],
          brightness: prop.brightness,
          saturation: prop.saturation,
          contrast: prop.contrast,
          opacity: prop.opacity
      };
      return colorProp;
    } 
    return null;
  }
}
